let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2AiXF")).then(() => parcelRequire('7hwF8'));